import React, { useContext } from "react";
import moment from "moment";
import { Link, useHistory, useParams } from "react-router-dom";
import { firestore } from "../firebase";
import { useUserProvider } from "../context/UserProvider";
import { useConfirm } from "material-ui-confirm";

import {
  Card,
  Box,
  IconButton,
  Typography,
  TableCell,
  TableRow,
  useMediaQuery,
  CardContent,
  Grid,
  TextField,
  Chip,
  Table,
  TableBody,
} from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Stack } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import DeleteIcon from "@mui/icons-material/Delete";

import stackedRoomsIcon from "../images/stacked_rooms_white.svg";
import sideRoomsIcon from "../images/side_rooms_white.svg";

import stackedRoomsIconDark from "../images/stacked_rooms_dark.svg";
import sideRoomsIconDark from "../images/side_rooms_dark.svg";

import { toast } from "react-toastify"; // then this

import { ColorModeContext } from "../context/ColorModeProvider";

function Wall({
  content,
  displayName,
  photoURL,
  registrationPeriod,
  createdAt,
  formData,
  user,
  wall,
  site,
  siteStreet,
  siteNumber,
  // props,
  id: wallId,
}) {
  const { theme } = useContext(ColorModeContext);
  // const { siteid } = useParams();
  const existingField_before_stacked = [
    // Horizontal Wall (Before Works)
    formData.horizontalWallOverlay,
    formData.horizontalWallCoating,
    formData.horizontalWallStructure,
    formData.horizontalWallCeiling,
    formData.horizontalWallSurface,
    formData.horizontalWallNotes,
    // Stacked Room 1 (Before Works)
    formData.stackedRoom1Name,
    formData.stackedRoom1TypeOf,
    formData.stackedRoom1Volume,
    formData.stackedRoom1LateralWall1,
    formData.stackedRoom1LateralWall2,
    formData.stackedRoom1LateralWall3,
    formData.stackedRoom1LateralWall4,
    formData.stackedRoom1Notes,
    // Stacked Room 2 (Before Works)
    formData.stackedRoom2Name,
    formData.stackedRoom2TypeOf,
    formData.stackedRoom2Volume,
    formData.stackedRoom2LateralWall1,
    formData.stackedRoom2LateralWall2,
    formData.stackedRoom2LateralWall3,
    formData.stackedRoom2LateralWall4,
    formData.stackedRoom2Notes,
  ];
  const existingField_before_side = [
    // Vertical Wall (Before Works)
    formData.verticalWallCoatingSideRoom1,
    formData.verticalWallStructure,
    formData.verticalWallCoatingSideRoom2,
    formData.verticalWallSurface,
    formData.verticalWallNotes,
    // Side Room 1 (Before Works)
    formData.sideRoom1Name,
    formData.sideRoom1TypeOf,
    formData.sideRoom1Volume,
    formData.sideRoom1LateralWall1,
    formData.sideRoom1LateralWall2,
    formData.sideRoom1Ceiling,
    formData.sideRoom1CeilingStructure,
    formData.sideRoom1FloorCoating,
    formData.sideRoom1FloorStructure,
    formData.sideRoom1Notes,
    // Side Room 2 (Before Works)
    formData.sideRoom2Name,
    formData.sideRoom2TypeOf,
    formData.sideRoom2Volume,
    formData.sideRoom2LateralWall1,
    formData.sideRoom2LateralWall2,
    formData.sideRoom2Ceiling,
    formData.sideRoom2CeilingStructure,
    formData.sideRoom2FloorCoating,
    formData.sideRoom2FloorStructure,
    formData.sideRoom2Notes,
  ];
  const existingField_after_stacked = [
    // Horizontal Wall (After Works)
    formData.horizontalWallOverlay,
    // formData.horizontalWallOverlayInterventions,
    formData.horizontalWallCoating,
    // formData.horizontalWallCoatingInterventions,
    formData.horizontalWallStructure,
    // formData.horizontalWallStructureInterventions,
    formData.horizontalWallCeiling,
    // formData.horizontalWallCeilingInterventions,
    formData.horizontalWallSurface,
    formData.horizontalWallNotes,
    // Stacked Room 1 (After Works)
    formData.stackedRoom1Name,
    formData.stackedRoom1TypeOf,
    formData.stackedRoom1Volume,
    formData.stackedRoom1LateralWall1,
    formData.stackedRoom1LateralWall2,
    formData.stackedRoom1LateralWall3,
    formData.stackedRoom1LateralWall4,
    formData.stackedRoom1Notes,
    // Stacked Room 2 (After Works)
    formData.stackedRoom2Name,
    formData.stackedRoom2TypeOf,
    formData.stackedRoom2Volume,
    formData.stackedRoom2LateralWall1,
    formData.stackedRoom2LateralWall2,
    formData.stackedRoom2LateralWall3,
    formData.stackedRoom2LateralWall4,
    formData.stackedRoom2Notes,
  ];
  const existingField_after_side = [
    // Vertical Wall (After Works)
    formData.verticalWallCoatingSideRoom1,
    // formData.verticalWallCoatingSideRoom1Interventions,
    formData.verticalWallStructure,
    // formData.verticalWallStructureInterventions,
    formData.verticalWallCoatingSideRoom2,
    // formData.verticalWallCoatingSideRoom2Interventions,
    formData.verticalWallSurface,
    formData.verticalWallNotes,
    // Side Room 1 (After Works)
    formData.sideRoom1Name,
    formData.sideRoom1TypeOf,
    formData.sideRoom1Volume,
    formData.sideRoom1LateralWall1,
    formData.sideRoom1LateralWall2,
    formData.sideRoom1Ceiling,
    formData.sideRoom1CeilingStructure,
    formData.sideRoom1FloorCoating,
    formData.sideRoom1FloorStructure,
    formData.sideRoom1Notes,
    // Side Room 2 (After Works)
    formData.sideRoom2Name,
    formData.sideRoom2TypeOf,
    formData.sideRoom2Volume,
    formData.sideRoom2LateralWall1,
    formData.sideRoom2LateralWall2,
    formData.sideRoom2Ceiling,
    formData.sideRoom2CeilingStructure,
    formData.sideRoom2FloorCoating,
    formData.sideRoom2FloorStructure,
    formData.sideRoom2Notes,
  ];

  function isEmptyString(operand) {
    return operand != "" ? "full" : "empty";
  }

  function isEmpty(current) {
    return isEmptyString(current) === "full" ? true : false;
  }

  const confirm = useConfirm();

  const { id: siteId } = useParams();

  // const { id } = useParams();

  const siteRef = firestore.doc(`sites/${siteId}`);
  const wallsRef = siteRef.collection("walls");
  // const wallRef = wallsRef.doc(`walls/${id}`);

  // const wallRef = firestore
  //   .doc(`sites/${id}`)
  //   .collection("walls")
  //   .doc(`walls/${id}`);

  const remove = () =>
    siteRef
      .collection("walls")
      .doc(wallId)
      .delete()
      .then(() =>
        //  Alert.info("Post Deleted", 3000)
        toast.info("Wall deleted", {
          theme: "colored",
        })
      );

  const { user: currentUser } = useUserProvider();
  const location = useHistory().location.pathname;

  const belongsToCurrentUser = (currentUser, siteAuthor) => {
    if (!currentUser) return false;

    return currentUser.uid === siteAuthor.uid;
  };

  const handleDelete = () => {
    confirm({
      title: "Are you sure?",
      description: "This will permanently delete this wall.",
    }).then(() => remove());
  };
  const registr = formData.registrationPeriod;

  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  const isMediumScreenAndDown = useMediaQuery((theme) =>
    theme.breakpoints.down("md")
  );

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  return (
    <>
      <Card
        elevation={0}
        sx={{
          marginBottom: {
            xs: "14px",
            sm: "22px",
            md: "22px",
            lg: "22px",
          },
        }}
      >
        <Table>
          <TableBody>
            <TableRow
              style={{
                width: "100%",
                borderBottom: "none",
              }}
            >
              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "purple",
                  width: {
                    xs: "50%",
                    sm: "30%",
                    md: "30%",
                    lg: "30%",
                  },
                  pl: {
                    xs: 2,
                    sm: 3,
                    md: 3,
                    lg: 3,
                  },
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                size="medium"
                // colSpan={6}
                align="left"
                // style={{ width: "30%" }}
              >
                <Typography variant="body2">
                  {formData.stackedRoom1Name || formData.sideRoom1Name}
                </Typography>
                <Typography variant="body2">
                  / {formData.stackedRoom2Name || formData.sideRoom2Name}
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  borderBottom: "none",
                  // background: "red",
                  pl: 0,
                  pr: 0,
                }}
                // size="medium"
                // colSpan={6}
                align="right"
              >
                {formData.registrationPeriod === "Before Works" &&
                formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" &&
                theme.palette.mode === "dark" ? (
                  <img src={stackedRoomsIcon} align="center" width="40px" />
                ) : formData.registrationPeriod === "Before Works" &&
                  formData.roomDisposalDependingBeforeWorks ===
                    "Stacked Rooms" &&
                  theme.palette.mode === "light" ? (
                  <img src={stackedRoomsIconDark} align="center" width="40px" />
                ) : formData.registrationPeriod === "Before Works" &&
                  formData.roomDisposalDependingBeforeWorks ===
                    "Side By Side Rooms" &&
                  theme.palette.mode === "dark" ? (
                  <img src={sideRoomsIcon} align="center" width="40px" />
                ) : formData.registrationPeriod === "Before Works" &&
                  formData.roomDisposalDependingBeforeWorks ===
                    "Side By Side Rooms" &&
                  theme.palette.mode === "light" ? (
                  <img src={sideRoomsIconDark} align="center" width="40px" />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Stacked Rooms" &&
                  theme.palette.mode === "dark" ? (
                  <img src={stackedRoomsIcon} align="center" width="40px" />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Stacked Rooms" &&
                  theme.palette.mode === "light" ? (
                  <img src={stackedRoomsIconDark} align="center" width="40px" />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Side By Side Rooms" &&
                  theme.palette.mode === "dark" ? (
                  <img src={stackedRoomsIcon} align="center" width="40px" />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Side By Side Rooms" &&
                  theme.palette.mode === "light" ? (
                  <img src={stackedRoomsIconDark} align="center" width="40px" />
                ) : (
                  "err"
                )}
              </TableCell>
              {/* <TableCell>{formData.roomDisposalDependingAfterWorks}</TableCell> */}

              <TableCell
                sx={{
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  maxWidth: {
                    xs: "3.6em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  borderBottom: "none",
                  pt: "28px",
                  pb: "28px",
                  pl: 0,
                  pr: 0,
                  // clear: "both",
                }}
                size="small"
                // colSpan={6}
                align="center"
              >
                <Typography color="inherit" variant="subtitle1">
                  <Chip
                    style={{
                      // color: "#fff",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      fontSize: "0.8em",
                      letterSpacing: "0.5px",
                      padding: "0px 2px 0px 2px ",
                      textTransform: "uppercase",
                      height: "28px",
                      lineHeight: "28px",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      background: "transparent",
                    }}
                    // color="primary"
                    // icon={<TimelapseIcon fontSize="small" />}
                    label={
                      isMediumScreenAndDown
                        ? formData.registrationPeriod === "Before Works"
                          ? "BW"
                          : "AW"
                        : formData.registrationPeriod
                    }
                  />
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "yellow",
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },

                  p: 0,
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                size="small"
                align="right"
              >
                {formData.registrationPeriod === "Before Works" &&
                formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" &&
                // existingField_before_stacked.every != undefined &&

                existingField_before_stacked.every(isEmpty) ? (
                  <CheckCircleIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{
                      color: "#00BFC6",
                      justifyContent: "center",
                      mt: 1,
                    }}
                  />
                ) : formData.registrationPeriod === "Before Works" &&
                  formData.roomDisposalDependingBeforeWorks ===
                    "Side By Side Rooms" &&
                  // existingField_before_side.every != undefined &&
                  existingField_before_side.every(isEmpty) ? (
                  <CheckCircleIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{
                      color: "#00BFC6",
                      justifyContent: "center",
                      mt: 1,
                    }}
                  />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Stacked Rooms" &&
                  // existingField_after_stacked.every != undefined &&
                  existingField_after_stacked.every(isEmpty) ? (
                  <CheckCircleIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{
                      color: "#00BFC6",
                      justifyContent: "center",
                      mt: 1,
                    }}
                  />
                ) : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Side By Side Rooms" &&
                  // existingField_after_side.every != undefined &&
                  existingField_after_side.every(isEmpty) ? (
                  <CheckCircleIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{
                      color: "#00BFC6",
                      justifyContent: "center",
                      mt: 1,
                    }}
                  />
                ) : (
                  <TimelapseIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{ justifyContent: "center", color: "#8D9EB7", mt: 1 }}
                  />
                )}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "none",
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                align="right"
              >
                {user &&
                belongsToCurrentUser(currentUser, user) &&
                location !== `/wall/${wallId}` ? (
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete()}
                  >
                    <DeleteIcon
                      fontSize={isSmallScreen ? "small" : "medium"}
                      style={{ justifyContent: "center", color: "#6593B5" }}
                    />
                  </IconButton>
                ) : (
                  ""
                )}
              </TableCell>

              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "green",
                  width: "1em",
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pr: {
                    xs: 0.5,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                align="right"
              >
                <Link
                  to={{
                    pathname: `/walls/${wallId}/`,
                    state: {
                      siteId,
                      formData,
                      createdAt,
                      siteStreet,
                      siteNumber,
                    },
                    // `/walls/${propsWallId}`
                  }}
                >
                  <IconButton aria-label="edit">
                    <NavigateNextIcon />
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
    </>
  );
}

export default Wall;
